import React, { useState, useEffect } from "react";
import { fetchAPI } from '../../utils/api';
import MagneticButton from '../Miscellaneous/MagneticButton';

const CTAOne = () => {
	const [socials, setSocials] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const getData = async () => {
			try {
				const globalRes = await fetchAPI('/global', { populate: 'socialLinks' });
				if (globalRes?.data?.socialLinks) {
					setSocials(globalRes.data.socialLinks);
				}
			} catch (error) {
				// If 404, it probably means Global type isn't published/created yet.
				console.warn("Could not fetch CTA methods (likely missing in Strapi).", error.message);
			} finally {
				setLoading(false);
			}
		};
		getData();
	}, []);

	if (loading) return null; // Or a loader

	return (
		<section className="cta border-top border-light-subtle">
			<div className="container">
				<div className="row justify-content-center text-center">
					<div className="col-12 col-md-10 col-lg-7">
						<h2 className="title mb-0 mb-md-2">Schedule a call today!</h2>
						<div className="cta-text">
							<span className="line-item"></span>
							<span className="line"></span>
							<MagneticButton
								href="/contact"
							>
								Contact Us
							</MagneticButton>
						</div>

						{/* Socials */}
						<div className="socials mt-5">
							<nav className="nav justify-content-center">
								{socials.length > 0 ? (
									socials.map((social, index) => (
										<a key={index} className="nav-link swap-icon" href={social.url} target="_blank" rel="noopener noreferrer">
											{social.platform} <i className="icon rotate bi bi-arrow-right-short"></i>
										</a>
									))
								) : (
									<p>No social links available.</p>
								)}
							</nav>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CTAOne;

